module.exports = __webpack_public_path__ + "img/bubble2.4aaffa4c.svg";